export const OpcoesRentabilidadeAnual = [
    {
        Valor: "4", Nome: "4%"
    },
    {
        Valor: "5", Nome: "5%"
    },
    {
        Valor: "6", Nome: "6%"
    },
    {
        Valor: "7", Nome: "7%"
    },
    {
        Valor: "8", Nome: "8%"
    },
    {
        Valor: "9", Nome: "9%"
    },
    {
        Valor: "10", Nome: "10%"
    },
    {
        Valor: "11", Nome: "11%"
    },
    {
        Valor: "12", Nome: "12%"
    },
    {
        Valor: "13", Nome: "13%"
    },
    {
        Valor: "14", Nome: "14%"
    },
    {
        Valor: "15", Nome: "15%"
    }
]